<template>
  <div class="progress-bar">
    <div class="progress-bar-value" />
  </div>
</template>

<style lang="scss" src="./AppProgressLinear.scss" />
